let baseSize = 75
// 设置 rem 函数
function setRem (e) {
  // document.documentElement.clientWidth < 1200 && (baseSize = 10)
  let fontSizeNum = 75
  if (document.documentElement.clientWidth > 1200) {
    fontSizeNum = 75
  } else {
    fontSizeNum = document.documentElement.clientWidth / 1200 * baseSize 
  }
  // 设置页面根节点字体大小
  document.documentElement.style.fontSize = fontSizeNum + 'px'
}
// 初始化
setRem()
export default setRem
